import React, { useEffect, useRef, useState } from "react";
import { Avatar, Button, Col, Input, Modal, Row, Tabs } from "antd";
import {
  CloseOutlined,
  SearchOutlined,
  UserOutlined,
  StarOutlined,
  StarFilled,
} from "@ant-design/icons";
import { useNavigate, createSearchParams } from "react-router-dom";
import SearchIcon from "../../../Assets/search_icon.svg";
import CancelIcon from "../../../Assets/cancelIcon.svg";
import API_MANAGER from "../../../API";

const SearchModal = ({
  searchType,
  setSearchType,
  setIsSearchModalOpen,
  isSearchModalOpen,
  searchedData,
  searchText,
  centered,
  setSearchText,
  handleEnterButton,
}) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const [favourites, setFavourites] = useState([]);
  const [loadingFavourites, setLoadingFavourites] = useState(false);

  const showModal = () => {
    setIsSearchModalOpen(true);
  };
  const handleOk = () => {
    setIsSearchModalOpen(false);
  };
  const handleCancel = () => {
    setIsSearchModalOpen(false);
  };

  // Get favourites list
  const getFavourites = async () => {
    setLoadingFavourites(true);
    try {
      const response = await API_MANAGER.getAllFavourites();
      const favouritesList = response?.data?.data || [];
      setFavourites(favouritesList);
    } catch (error) {
      console.error("Error fetching favourites:", error);
    } finally {
      setLoadingFavourites(false);
    }
  };

  // Check if a candidate is in favourites
  const isInFavourites = (candidateId) => {
    return favourites.some(
      (fav) =>
        fav.candidateId?._id === candidateId ||
        fav.candidateId?.id === candidateId ||
        fav.candidateId === candidateId
    );
  };

  // Handle add/remove from favourites
  const handleFavouriteToggle = async (candidateId, candidateName) => {
    try {
      if (isInFavourites(candidateId)) {
        // Find the favourite entry to remove
        const favouriteEntry = favourites.find(
          (fav) =>
            fav.candidateId?._id === candidateId ||
            fav.candidateId?.id === candidateId ||
            fav.candidateId === candidateId
        );
        if (favouriteEntry) {
          await API_MANAGER.removeFavourite(favouriteEntry._id);
        }
      } else {
        // Add to favourites
        await API_MANAGER.addFavourite({
          candidateId: candidateId,
          candidateName: candidateName,
        });
      }
      // Refresh favourites list
      getFavourites();
    } catch (error) {
      console.error("Error toggling favourite:", error);
    }
  };

  // Handle View All button click
  const handleViewAll = () => {
    if (searchType === "favourites") {
      // Navigate to search page with favourites filter
      navigate(`/search?search=${searchText}&page=1&tab=favourites`);
    } else {
      // Regular search navigation
      navigate(`/search?search=${searchText}&page=1`);
    }
    setIsSearchModalOpen(false);
  };

  const shownCount = searchedData?.result?.length || 0;
  const totalCount = searchedData?.totalCount || 0;

  const ListRecord = () => {
    return (
      <>
        <div className="searchListRecordContainer">
          {searchedData?.result?.map((item, index) => (
            <Row justify={"space-between"} className="list-record">
              <Col style={{ width: "calc(100% - 52px)" }}>
                <Row
                  gutter={8}
                  align={"middle"}
                  className="cursor_pointer"
                  onClick={() => {
                    navigate(`/applicant-profile/${item?.userId}`, {
                      state: {
                        isViewable: item?.isViewable, //Needed
                        isInvited: item?.isInvited,
                        previousCurrentPage: "search",
                        search: true,
                        name: item?.name,
                      },
                    });
                    setIsSearchModalOpen(false);
                  }}
                >
                  <Col>
                    {item?.profileImage ? (
                      <Avatar
                        size={36}
                        src={item?.profileImage}
                        className="profile-icon text_blur"
                      />
                    ) : (
                      <Avatar
                        size={36}
                        icon={<UserOutlined />}
                        src={item?.profileImage}
                        className="profile-icon "
                      />
                    )}
                  </Col>
                  <Col
                    style={{ width: "calc(100% - 52px)" }}
                    className="candidateName"
                  >
                    {item?.name}
                  </Col>
                </Row>
              </Col>
              <Col>
                <Button
                  type="link"
                  onClick={() => {
                    navigate(`/applicant-profile/${item?.userId}`, {
                      state: {
                        isViewable: item?.isViewable,
                        isInvited: item?.isInvited,
                        previousCurrentPage: "search",
                        search: true,
                        name: item?.name,
                      },
                    });
                    setIsSearchModalOpen(false);
                  }}
                >
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 15.5L15 5.5M15 5.5H8.33333M15 5.5V12.1667"
                      stroke="#1638B1"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </Button>
              </Col>
            </Row>
          ))}
        </div>
      </>
    );
  };

  const FavouritesRecord = () => {
    // Filter favourites based on search text
    const filteredFavourites =
      searchText && searchText.trim()
        ? favourites.filter((favourite) => {
            const candidate = favourite.candidateId;
            const searchLower = searchText.toLowerCase();
            return (
              candidate?.name?.toLowerCase().includes(searchLower) ||
              candidate?.email?.toLowerCase().includes(searchLower) ||
              candidate?.discipline?.name
                ?.toLowerCase()
                .includes(searchLower) ||
              candidate?.city?.toLowerCase().includes(searchLower) ||
              candidate?.state?.toLowerCase().includes(searchLower)
            );
          })
        : [];

    return (
      <div className="searchListRecordContainer">
        {loadingFavourites ? (
          <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
            Loading favourites...
          </div>
        ) : !searchText || searchText.trim() === "" ? (
          <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
            {/* Enter search text to find favourites */}
          </div>
        ) : filteredFavourites.length > 0 ? (
          filteredFavourites.map((favourite, index) => {
            const candidate = favourite.candidateId;
            return (
              <Row justify={"space-between"} className="list-record">
                <Col style={{ width: "calc(100% - 52px)" }}>
                  <Row
                    gutter={8}
                    align={"middle"}
                    className="cursor_pointer"
                    onClick={() => {
                      navigate(`/applicant-profile/${candidate?.userId}`, {
                        state: {
                                //  isViewable: candidate?.isViewable,
                          isInvited: candidate?.isInvited,
                          previousCurrentPage: 'search',
                          search: true,
                          name: candidate?.name,
                        },
                      });
                      setIsSearchModalOpen(false);
                    }}
                  >
                    <Col>
                      {candidate?.profileImage ? (
                        <Avatar
                          size={36}
                          src={candidate?.profileImage}
                          className="profile-icon text_blur"
                        />
                      ) : (
                        <Avatar
                          size={36}
                          icon={<UserOutlined />}
                          src={candidate?.profileImage}
                          className="profile-icon "
                        />
                      )}
                    </Col>
                    <Col
                      style={{ width: "calc(100% - 52px)" }}
                      className="candidateName"
                    >
                      <Row align="middle" gutter={8}>
                        <Col>{candidate?.name}</Col>
                        <Col>
                          <Button
                            type="link"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleFavouriteToggle(
                                candidate?.userId,
                                candidate?.name
                              );
                            }}
                            style={{
                              color: "#ffd700",
                              padding: 0,
                              height: "auto",
                            }}
                          >
                            <StarFilled
                              style={{ color: "#ffd700", fontSize: "16px" }}
                            />
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Button
                    type="link"
                    onClick={() => {
                      navigate(`/applicant-profile/${candidate?.userId}`, {
                        state: {
                          // isViewable: candidate?.isViewable,
                          isInvited: candidate?.isInvited,
                          previousCurrentPage: 'search',
                          search: true,
                          name: candidate?.name,
                        },
                      });
                      setIsSearchModalOpen(false);
                    }}
                  >
                    <svg
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 15.5L15 5.5M15 5.5H8.33333M15 5.5V12.1667"
                        stroke="#1638B1"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </Button>
                </Col>
              </Row>
            );
          })
        ) : (
          <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
            No favourites found matching your search
          </div>
        )}
      </div>
    );
  };

  const items = [
    {
      key: "all",
      label: " All Results",
      children: ListRecord(),
    },
    {
      key: "candidates",
      label: "Candidates",
      children: ListRecord(),
    },
    {
      key: "discipline",
      label: "Disciplines",
      children: ListRecord(),
    },
    {
      key: "favourites",
      label: "Favourites",
      children: FavouritesRecord(),
    },
  ];
  const handleInputChange = (e) => {
    setSearchText(e);
    // handleEnterButton();
  };
  useEffect(() => {
    setTimeout(() => {
      inputRef?.current?.focus({
        cursor: "end",
      });
    }, 200);
  }, [isSearchModalOpen, inputRef]);

  // Load favourites when modal opens
  useEffect(() => {
    if (isSearchModalOpen) {
      getFavourites();
    }
  }, [isSearchModalOpen]);

  // Save search type to localStorage when it changes
  useEffect(() => {
    if (searchType) {
      localStorage.setItem("searchTabType", searchType);
    }
  }, [searchType]);

  return (
    <Modal
      title={
        <Row justify={"space-between"}>
          <Col className="w-100">
            <Row align={"middle"} gutter={12}>
              {/* <Col xs={2}>
                <img src={SearchIcon} alt="icon" />
              </Col> */}
              <Col xs={24} className="searchModalTitle">
                <Input
                  prefix={<img src={SearchIcon} alt="icon" />}
                  ref={inputRef}
                  autoFocus
                  suffix={
                    searchText && (
                      <img
                        src={CancelIcon}
                        className="cursor_pointer"
                        alt="cross"
                        onClick={() => {
                          setSearchText("");
                          handleEnterButton();
                        }}
                      />
                    )
                  }
                  className="searchModalInputBox"
                  value={searchText}
                  onChange={(e) => handleInputChange(e.target.value)}
                />
              </Col>
              {/* <Col
                xs={2}
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => setIsSearchModalOpen(false)}
              ></Col> */}
            </Row>
          </Col>
        </Row>
      }
      open={isSearchModalOpen}
      onCancel={handleCancel}
      className=""
      wrapClassName="search-modal-main-container"
      closeIcon={false}
      footer={null}
      centered={centered ? true : false}
      getContainer={document.body}
      zIndex={9999}
    >
      <Row justify={"space-between"} className="mt-20">
        <Col className="searchBy">
          {searchType === "favourites"
            ? (() => {
                if (!searchText || searchText.trim() === "") {
                  return `${searchedData?.result?.length || 0} results found`;
                }
                const filteredFavourites = favourites.filter((favourite) => {
                  const candidate = favourite.candidateId;
                  const searchLower = searchText.toLowerCase();
                  return (
                    candidate?.name?.toLowerCase().includes(searchLower) ||
                    candidate?.email?.toLowerCase().includes(searchLower) ||
                    candidate?.discipline?.name
                      ?.toLowerCase()
                      .includes(searchLower) ||
                    candidate?.city?.toLowerCase().includes(searchLower) ||
                    candidate?.state?.toLowerCase().includes(searchLower)
                  );
                });
                return `${filteredFavourites.length} favourites found`;
              })()
            : `Showing ${shownCount} of ${totalCount} results`}
        </Col>
        <Col>
          <Button
            type="link"
            onClick={handleViewAll}
            className="viewAll"
            style={{
              cursor: `${
                searchedData?.result?.length > 0 ? "pointer" : "not-allowed"
              }`,
              color: `${
                searchedData?.result?.length > 0 ? "#071135" : "#a7aebb"
              }`,
            }}
          >
            View All
          </Button>
        </Col>
      </Row>
      <Tabs
        defaultActiveKey="1"
        items={items}
        onChange={(e) => setSearchType(e)}
      />

      <Row justify={"end"} className="mt-20" gutter={16}>
        <Col>
          {" "}
          <Button
            className="cancel_btn"
            onClick={() => {
              handleInputChange(null);
              setIsSearchModalOpen(false);
            }}
          >
            Cancel
          </Button>
        </Col>
        <Col>
          {" "}
          <Button
            className="black_color_button"
            onClick={() => {
              if (searchedData?.result?.length > 0) {
                handleViewAll();
              }
            }}
            disabled={searchedData?.result?.length < 1}
          >
            View All
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};

export default SearchModal;
